
export class FreePassRequestDto {
  passId: string;
  userIds: string[];
  emails: string[];
}
